import React from 'react';
import { NavLink } from 'react-router-dom';
const Step9Success = () => {
   return (
      <div className="modal_content_body text-center">
         <img
            src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'}
            alt=""
            style={{ width: '100px' }}
            className="d-block mb-4 mx-auto"
         />
         <h3 className="ppt_form_title mb-3 text-center mx-lg-auto col-lg-8">
            You've completed succesfully KYC Process
         </h3>
         <p className="col-lg-9 mx-lg-auto">
            Your account is currently under review and is expected to be live within the next 24-48 hours. Once verified, you'll be able to start buying ProperT tokens and other cryptocurrencies.
         </p>
         <small className="d-block col-lg-8 mx-lg-auto">
            <strong className="text-danger">
               <img
                  src={process.env.PUBLIC_URL + '/assets/img/icon_warning_red.svg'}
                  alt=""
                  style={{ width: '14px', transform: 'translateY(-1px)' }}
               /> Warning:
            </strong> Watch for emails from ProperT LLC in case additional documents are needed to complete your KYC verification.
         </small>
         <div className="d-flex justify-content-center gap-3 pt-4">
            <NavLink className="ppt_btn_primary alt" to="/dashboard">
               Go to Dashboard
            </NavLink>
         </div>
      </div>
   );
};
export default Step9Success;